module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 17.fd022acf.wav";